import type { ExtraProfileField } from "@jti/fe-common/types";
import type { FormTarget, OrderAttribute } from "@jti/magento";

export const filterToVisibleAttributes = (
  attrs: OrderAttribute[],
  userAttributes: ExtraProfileField,
  target: FormTarget
) => {
  const excluded = new Set(Object.keys(userAttributes || {}));

  return attrs.filter((a) => a.placement === target && !excluded.has(a.code));
};
